import {
  WindowWidthStoreAction,
  WindowWidthStoreKind,
  WindowWidthStoreType,
} from './windowWidthStore.types';

export const INITIAL_IS_MOBILE_VIEW = {
  isMobileView: window.innerWidth < 499,
};

const windowWidthStore = (
  state: WindowWidthStoreType,
  action: WindowWidthStoreAction
): WindowWidthStoreType => {
  switch (action.type) {
    case WindowWidthStoreKind.INITIAL: {
      return { ...state, ...action.payload };
    }
    default:
      throw new Error();
  }
};

export default windowWidthStore;
